import colors from '@mathflat/common/style/colors'
import clsx from 'clsx'
import { computed } from 'mobx'
import { observer } from 'mobx-react'

import { Icon } from '@/component/atoms/Icon'
import Name from '@/component/atoms/Name'
import useRepository from '@/hooks/useRepository'
import type { ServiceNameT } from '@/service/StudentGroupAccordion.service'
import StudentGroupAccordionService from '@/service/StudentGroupAccordion.service'
import type { RouteKey } from '@/types'

import S from './StudentGroupAccordion.style'

type Props = {
  routeKey: RouteKey
}

const AccordionOpenButton = ({ routeKey }: Props) => {
  const service = useRepository([StudentGroupAccordionService, routeKey], routeKey as ServiceNameT)

  const isStudent = computed(() => service.selectedGroupInfo?.data.type === 'student').get()

  return (
    <button
      className={clsx(service.isFloated && 'floated')}
      css={S.accordionOpenButton}
      onClick={() => service.setIsAccordionShow(!service.isAccordionShow)}
    >
      <Icon name={isStudent ? 'person' : 'people'} size={16} color={colors.gray.$700} />
      <div className="button-label">
        <p>
          <Name
            textAlign="left"
            maxWidth="auto"
            normalTypo="caption01"
            smallTypo="caption02"
            smallSizeLength={12}
          >{`${service.selectedGroupInfo?.name ?? ''} ${isStudent ? '학생' : ''}`}</Name>
        </p>
      </div>
      <Icon
        className={clsx('chevron_double_right', service.isAccordionShow && 'show')}
        name="chevron_double_right"
        size={10}
        color={colors.gray.$700}
      />
    </button>
  )
}

export default observer(AccordionOpenButton)
